var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.editStatus
    ? _c(
        "div",
        {
          staticClass: "v-text",
          on: { keydown: _vm.handleKeydown, keyup: _vm.handleKeyup },
        },
        [
          _vm.canEdit
            ? _c("div", {
                ref: "text",
                class: { canEdit: _vm.canEdit },
                style: { verticalAlign: _vm.element.style.verticalAlign },
                attrs: {
                  contenteditable: _vm.canEdit,
                  tabindex: _vm.element.id,
                },
                domProps: {
                  innerHTML: _vm._s(_vm.$xss(_vm.element.propValue)),
                },
                on: {
                  dblclick: _vm.setEdit,
                  paste: _vm.clearStyle,
                  mousedown: _vm.handleMousedown,
                  blur: _vm.handleBlur,
                  input: _vm.handleInput,
                },
              })
            : _vm._e(),
          !_vm.canEdit
            ? _c("div", {
                style: { verticalAlign: _vm.element.style.verticalAlign },
                domProps: {
                  innerHTML: _vm._s(_vm.$xss(_vm.element.propValue)),
                },
                on: {
                  dblclick: _vm.setEdit,
                  paste: _vm.clearStyle,
                  mousedown: _vm.handleMousedown,
                  blur: _vm.handleBlur,
                  input: _vm.handleInput,
                },
              })
            : _vm._e(),
        ]
      )
    : _c("div", { staticClass: "v-text" }, [
        _c("div", {
          style: { verticalAlign: _vm.element.style.verticalAlign },
          domProps: { innerHTML: _vm._s(_vm.$xss(_vm.textInfo)) },
        }),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }